import React, { useState } from 'react';
const prompts = [
  "למה אתם מצפים בזמן הקרוב?",
  "איך נראה אחר צהריים פנוי ומושלם מבחינתכם?",
  "איזה דבר קטן תמיד מעלה לכם חיוך?",
  "מה ניסיתם לאחרונה בפעם הראשונה?",
  "איזה מקום הייתם שמחים להראות למישהו?",
];
export default function ConversationPrompt() {
  const [index, setIndex] = useState(0);
  return <aside className="conversation-prompt">
    <span>קצת השראה</span>
    <p aria-live="polite">{prompts[index]}</p>
    <button onClick={() => setIndex(value => (value + 1) % prompts.length)}>שאלה נוספת</button>
  </aside>;
}
